/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qc_No_Fixable_IssuesInputs */



/**
* | output |
* | --- |
* | "No automatically fixable issues found." |
*
* @param {Qc_No_Fixable_IssuesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_no_fixable_issues = /** @type {((inputs?: Qc_No_Fixable_IssuesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_No_Fixable_IssuesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun problème corrigible automatiquement trouvé.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine automatisch korrigierbaren Probleme gefunden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun problema correggibile automaticamente trovato.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проблем, исправимых автоматически, не найдено.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontraron problemas corregibles automáticamente.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未找到可自动修复的问题。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動修正可能な問題は見つかりませんでした。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वचालित रूप से ठीक की जा सकने वाली कोई समस्या नहीं मिली।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não foram encontrados problemas corrigíveis automaticamente.")
	return /** @type {LocalizedString} */ ("No automatically fixable issues found.")
});